import axios from "axios";

export class ResetPaswordFunction {
  ErrorValidationConstant =
    "The password must be 8 to 20 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.";

  ErrorValidationConstant2 = "Password does not match.";
  async ResetPasword(
    body,
    Navigate,
    setToastConfig,
    toastConfig,
    setvalidation,
    token,
    setLoading
  ) {
    setLoading(true);
    await axios
      .patch(
        `${process.env.REACT_APP_API_URL}/api/v1/user/reset/password`,
        body,
        {
          headers: {
            token,
          },
        }
      )
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          Navigate("/login");
        }
      })
      .catch((err) => {
        setLoading(false);
        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }
}
